import React from "react";
import * as d3 from "d3";

const Axis = ({type, scale, ticks, tickFormat, tickSize, disableAnimation, ...props}) => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    const axisGenerator = type == "left" ? d3.axisLeft : d3.axisBottom;
    const axis = axisGenerator(scale)
      .ticks(ticks)
      .tickSize(tickSize)
      .tickFormat(tickFormat);

  const axisGroup = d3.select(ref.current);

  if (disableAnimation) {
      axisGroup.call(axis);
    } else {
      axisGroup.transition()
        .duration(750)
        .ease(d3.easeLinear)
        .call(axis);
    }

    axisGroup.select(".domain").remove();
    // axisGroup.selectAll("line").remove();

    axisGroup.selectAll("text")
      .attr("class", "axis label");
  }, [scale, ticks, tickFormat, disableAnimation]);

  return <g ref={ref} {...props} />;
};

export default Axis;
